import{B as N}from"./chunk-BaseElement-COVKFV2h.js";import{c as O}from"./chunk-constructorio-D-2AQC0s.js";import{a as L,b as j}from"./chunk-price-filter-GAuhIV8Y.js";import{x as o,T as x}from"./chunk-lit-element-CULRVKo8.js";import{c as w}from"./chunk-repeat-CLr2jifB.js";import{t as E}from"./chunk-custom-element-BhZVzxrc.js";import{n as g}from"./chunk-property-BXqvfTtY.js";import"./chunk-directive-CF8sV3Lr.js";import"./chunk-directive-helpers-R4cBqjor.js";var G=Object.defineProperty,V=Object.getOwnPropertyDescriptor,m=(t,e,a,s)=>{for(var r=s>1?void 0:s?V(e,a):e,n=t.length-1,i;n>=0;n--)(i=t[n])&&(r=(s?i(e,a,r):i(r))||r);return s&&r&&G(e,a,r),r};let h=class extends N{constructor(){super(...arguments),this.textSort="",this.textFilter="",this.textFilterCounter="",this.textFiltersCounter="",this.textDataSeeResult="",this.textDataSeeResults="",this.textHideCount="",this.textViewAllCount="",this.textApply="",this.textNoOptionsMatchSearch="",this.textClearAll="",this.dataResultsGridWithCountOne="",this.dataResultsGridWithCountOther="",this.type="",this.facetsCheckboxVisibleLimit=8,this.currentPage=1,this.resultsPerPage=16,this.resourcesData={},this.textFilterResults="",this._constructorResponseID=0,this._facetSearchQuery={}}connectedCallback(){super.connectedCallback(),this.fetchAllResources()}async fetchAllResources(){try{const t=await this.getPaginatedResults();if(t){const{results:e,totalPages:a,facets:s,sortOptions:r,totalResults:n}=t;if(!e)return;const i=e.length>0?e.map(l=>{var d,b,y;return{handle:(d=l.data)==null?void 0:d.handle,type:((b=l.data)==null?void 0:b.type)??"",id:((y=l.data)==null?void 0:y.id)??""}}):[];this.resourcesData={sortOptions:r,facets:s,cards:i,paginationIds:Array.from({length:a},(l,d)=>d+1),totalResults:n};const p=this.getTotalFiltersApplied(this.resourcesData.facets);this.textFilterResults=p==0?this.textFilter:p>1?this.textFiltersCounter:this.textFilterCounter,p>0&&(this.textFilterResults=this.textFilterResults.replace("{{ count }}",String(p)))}}catch(t){console.error("Error fetching browse results:",t)}}async getPaginatedResults(t=1,e=16,a={},s=""){var r,n,i,p;try{const l=await O.browse({filterName:"type",filterValue:this.type,section:"Articles",resultsPerPage:e,page:t,filters:a,sortBy:s,sortOrder:s.includes("ascending")?"ascending":"descending"},{enabled:!0,expiryMs:12e4}),d=(r=l==null?void 0:l.response)==null?void 0:r.results,b=(n=l==null?void 0:l.response)==null?void 0:n.total_num_results,y=Math.ceil((b??1)/this.resultsPerPage),$=(i=l==null?void 0:l.response)==null?void 0:i.facets,c=(p=l==null?void 0:l.response)==null?void 0:p.sort_options;return{results:d,totalPages:y,currentPage:t,facets:$,sortOptions:c,totalResults:b}}catch(l){return console.error("Constructor.io pagination error:",l),null}}async filterChanged(t,e){var $;if(!t)return;const a=e==null?void 0:e.hasAttribute("target-clear-all-filters");if(e)if(e.id.toLowerCase().includes("mobile")){if(e.getAttribute("type")==="radio"){const c=document.querySelector('select[name="sort_by"]');c&&(c.value=e.value,c.dispatchEvent(new Event("change",{bubbles:!0})))}else{const c=e.id.replace("Mobile","Desktop"),u=document.getElementById(c);u&&(u.checked=e.checked,u.dispatchEvent(new Event("change",{bubbles:!0})))}return}else if(e.tagName.toLowerCase()==="select"){const c=document.querySelector(`[type="radio"][name="sort_by"][value="${e.value}"]`);c.checked=!0}else{const c=document.getElementById(e.id.replace("Desktop","Mobile"));c&&(e.type=="checkbox"?c.checked=e.checked:c.value=e.value)}const s=($=t.querySelector("#SortOptionsFormDesktop select"))==null?void 0:$.value;let r=1;const n=t.querySelector("[aria-current='page']");n&&!e&&n.textContent&&(r=parseFloat(n.textContent));const i=parseFloat(t.getAttribute("data-pagination-results-per-page")),p=t.querySelector("[target-filters]"),l=new FormData(p),d={};for(const[c,u]of l.entries())d[c]?Array.isArray(d[c])?d[c].push(u):d[c]=[d[c],u]:d[c]=u;const b={};if(!a)for(const[c,u]of Object.entries(d))c!=="sort_by"&&(b[c]=u);this.scrollIntoView();const y=await this.getPaginatedResults(r,i,b,s);if(this._constructorResponseID++,y){const{results:c,totalPages:u,facets:v,sortOptions:M,totalResults:z}=y,S=c&&c.length>0?c.map(f=>{var k,C,_,R,A,D;return(k=f.data)!=null&&k.handle&&((C=f.data)!=null&&C.type)&&((_=f.data)!=null&&_.id)?{handle:(R=f.data)==null?void 0:R.handle,type:(A=f.data)==null?void 0:A.type,id:(D=f.data)==null?void 0:D.id}:{}}):[];if(!S)return;const P=(v==null?void 0:v.filter(f=>(f==null?void 0:f.type)==="multiple").map(f=>({...f,opened:Array.isArray(f.options)&&f.options.some(k=>k.status!=="")})))??[];this.resourcesData={sortOptions:M,cards:S,facets:P,paginationIds:Array.from({length:u},(f,k)=>k+1),totalResults:z};const F=this.getTotalFiltersApplied(this.resourcesData.facets);this.textFilterResults=F==0?this.textFilter:F>1?this.textFiltersCounter:this.textFilterCounter,F>0&&(this.textFilterResults=this.textFilterResults.replace("{{ count }}",String(F))),this.scrollIntoView({behavior:"smooth",block:"start"})}}paginateHandleClick(t){var r,n;const e=t.target,a=(n=(r=e.parentElement)==null?void 0:r.parentElement)==null?void 0:n.querySelectorAll("button:not([data-direction])"),s=parseInt(e==null?void 0:e.textContent);this.currentPage=s,a==null||a.forEach(i=>{var d;const l=parseInt((d=i.querySelector("span"))==null?void 0:d.textContent)==s;i.classList.toggle("border-t-foreground",l),i.classList.toggle("border-t-border",!l),l?(i.setAttribute("aria-current","page"),this.filterChanged(e.closest("search-results-section"))):i.removeAttribute("aria-current")})}paginateArrowClick(t){var r,n,i,p;const e=t.target,a=(n=(r=e.parentElement)==null?void 0:r.parentElement)==null?void 0:n.querySelector("[aria-current='page']"),s=(p=(i=e.parentElement)==null?void 0:i.parentElement)==null?void 0:p.querySelectorAll("button:not([data-direction])");if(a&&s&&e){const l=Array.from(s).indexOf(a),d=parseFloat(e==null?void 0:e.getAttribute("data-direction"));d>0&&l<s.length-1&&s[l+1].click(),d<0&&l>0&&s[l-1].click()}}applyFilterEvent(t){const e=t.target;this.currentPage=1,this.filterChanged(e.closest("search-results-section"),e)}clearAllFilters(t){t.preventDefault(),this.applyFilterEvent(t)}handleSelectChange(t){this.applyFilterEvent(t)}handleCheckboxChange(t){this.applyFilterEvent(t)}handleize(t){return t.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,"")}getFacetSearchKey(t,e="Desktop"){return`${t}-${e}`}getFacetSearchValue(t,e="Desktop"){return this._facetSearchQuery[this.getFacetSearchKey(t,e)]??""}handleFacetSearchInput(t,e,a="Desktop"){const s=t.target,r=this.getFacetSearchKey(e,a);this._facetSearchQuery={...this._facetSearchQuery,[r]:s.value},this.requestUpdate()}getFilteredFacetOptions(t=[],e=""){if(!e.trim())return t;const a=e.toLowerCase();return t.filter(s=>s.display_name.toLowerCase().includes(a))}getTotalFiltersApplied(t){return(t==null?void 0:t.reduce((e,a)=>{const s=a.type!="range"?a.options.filter(r=>r.status==="selected").length:0;return e+s},0))||0}getFacetsHTML(t,e,a){var n,i,p;const s=this.getTotalFiltersApplied(t),r=s==0?this.textApply.replace("{{ count }}","0"):(((n=this.resourcesData)==null?void 0:n.totalResults)??0)>1?this.textDataSeeResults:this.textDataSeeResult;return o`
      <div class="flex h-full w-full flex-col">
        <div
          class="flex-grow${e=="Mobile"?" overflow-auto":x}"
        >
          ${w(t??[],l=>l.name+e+this._constructorResponseID,l=>{var d;return o` ${((d=l.display_name)==null?void 0:d.toLowerCase())!="type"?o` <details
                    class="group/details border-b border-t-border"
                    ?open="${e!="Mobile"||l.opened}"
                  >
                    <summary
                      class='focus-inset group/filter-dropdown md:after:content-[" "] relative flow-root cursor-pointer max-md:px-xs max-md:py-md md:pointer-events-none md:cursor-auto md:pb-xs md:pt-sm md:after:pointer-events-none md:after:absolute md:after:left-0 md:after:top-0 md:after:z-10 md:after:block md:after:h-full md:after:w-full'
                    >
                      <div
                        class="flex w-full items-center justify-between text-sm"
                      >
                        <span
                          class="${window.brand=="NG"?"text-t-foreground-secondary":""} text-heading-6 font-medium capitalize"
                          >${l.display_name}</span
                        >
                        <span class="hidden group-open/details:block">
                          <svg-icon
                            src="icon-minus"
                            class="block md:hidden"
                            style="--icon-size: 13px;"
                          ></svg-icon>
                        </span>
                        <span class="block group-open/details:hidden">
                          <svg-icon
                            src="icon-plus"
                            class="block md:hidden"
                            style="--icon-size: 13px;"
                          ></svg-icon>
                        </span>
                      </div>
                    </summary>
                    ${o`
                      ${l.type==="multiple"?o`
                            ${(()=>{const b=l.options.length>20,y=b?this.getFacetSearchValue(l.name,e):"",$=b?this.getFilteredFacetOptions(l.options,y):l.options,c=$.length>this.facetsCheckboxVisibleLimit;return o`
                                <div
                                  class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                                >
                                  ${b?o`
                                        <div class="mb-sm">
                                          <label
                                            class="sr-only"
                                            for="Filter-filter.p.${this.handleize(l.name)}-${e}-search"
                                            >Search ${l.display_name}</label
                                          >
                                          <div class="relative">
                                            <input
                                              type="search"
                                              class="${window.brand!=="TFC"?"rounded-[0.375rem] bg-transparent":""} text-body w-full border border-t-border px-xs py-[0.625rem] pr-[2.75rem] text-t-foreground-secondary outline-none focus:border-t-foreground [&::-webkit-search-cancel-button]:appearance-none"
                                              id="Filter-filter.p.${this.handleize(l.name)}-${e}-search"
                                              placeholder="Search ${l.display_name}"
                                              .value=${y}
                                              @input=${u=>this.handleFacetSearchInput(u,l.name,e)}
                                            />
                                            <span
                                              class="${window.brand!=="TFC"?"border-l border-t-border":""} pointer-events-none absolute right-px top-px flex h-[calc(100%-2px)] w-10 items-center justify-center"
                                            >
                                              <svg-icon
                                                src="icon-search"
                                                class="block"
                                                style="--icon-size: 18px;"
                                              ></svg-icon>
                                            </span>
                                          </div>
                                        </div>
                                      `:x}
                                  ${$.length>0?o`
                                        <ul
                                          class="list-unstyled space-y-2xs"
                                          role="list"
                                        >
                                          ${w($,u=>u.value,(u,v)=>o` ${u.display_name!=""?o` <li
                                                    class=${v>=this.facetsCheckboxVisibleLimit&&c?'group-has-[toggle-button[data-toggled="false"]]/facet:hidden':""}
                                                  >
                                                    <div
                                                      class="group/checkbox inline-flex items-center justify-start gap-x-xs"
                                                    >
                                                      <label
                                                        class="relative flex cursor-pointer items-center overflow-clip rounded-[1px]"
                                                        for="Filter-filter.p.${this.handleize(u.display_name)}-${e}-${v}"
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          class="${window.brand=="NG"?"rounded-[2px] border-t-foreground-secondary":"border-blue-gray-200"} peer relative size-4 cursor-pointer appearance-none border transition-all checked:border-t-foreground disabled:border-t-border"
                                                          id="Filter-filter.p.${this.handleize(u.display_name)}-${e}-${v}"
                                                          value="${u.value}"
                                                          name="${l.name}"
                                                          aria-labelledby="Filter-filter.p.${this.handleize(u.display_name)}-${e}-${v}_label"
                                                          .checked=${u.status!==""}
                                                          @change=${this.handleCheckboxChange}
                                                        />
                                                        <span
                                                          class="${window.brand=="NG"?"bg-t-foreground-secondary":"bg-p-darkest"} pointer-events-none absolute left-2/4 top-2/4 flex size-3 h-full w-full -translate-x-2/4 -translate-y-2/4 items-center justify-center text-p-lightest opacity-0 transition-opacity peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-border"
                                                        >
                                                          <svg-icon
                                                            src="icon-checkbox-tick"
                                                            class="block"
                                                            style="--icon-size: 12px;"
                                                          ></svg-icon>
                                                        </span>
                                                      </label>
                                                      <label
                                                        class="text-body mt-px cursor-pointer select-none text-balance capitalize text-t-foreground group-has-[:disabled]/checkbox:text-t-border"
                                                        for="Filter-filter.p.${this.handleize(u.display_name)}-${e}-${v}"
                                                      >
                                                        ${u.display_name}
                                                      </label>
                                                    </div>
                                                  </li>`:x}`)}
                                        </ul>
                                      `:o`
                                        <p
                                          class="text-body mt-xs text-t-foreground"
                                        >
                                          ${this.textNoOptionsMatchSearch}
                                        </p>
                                      `}
                                  ${c?o`
                                        <toggle-button
                                          role="button"
                                          data-toggled="false"
                                          class="group/toggle-button ${window.brand=="NG"?"text-t-foreground-secondary font-bold":"text-t-foreground"} text-utility-bold mt-md underline md:mt-xs"
                                        >
                                          <span
                                            class='group-data-[toggled="true"]/toggle-button:hidden'
                                            >${this.textViewAllCount.replace("{{ count }}",`${$.length}`)}</span
                                          >
                                          <span
                                            class='group-data-[toggled="false"]/toggle-button:hidden'
                                            >${this.textHideCount.replace("{{ count }}",`${$.length-this.facetsCheckboxVisibleLimit}`)}</span
                                          >
                                        </toggle-button>
                                      `:x}
                                </div>
                              `})()}
                          `:x}
                    `}
                  </details>`:x}`})}
        </div>
        ${e=="Mobile"?o`
              <div
                class="group/toggle-clear-all flex w-full flex-col items-center justify-center gap-xs border-t border-t-border bg-t-background px-pagegridmargin py-sm"
                data-show-clear-all=${(s??0)>0}
              >
                <dialog-toggle modal-id="${a}" class="w-full">
                  <button class="btn w-full" variant="primary">
                    ${(r==null?void 0:r.replace("{{ count }}",((p=(i=this.resourcesData)==null?void 0:i.totalResults)==null?void 0:p.toString())??""))??""}
                  </button>
                </dialog-toggle>
                <button
                  class='text-utility-bold block cursor-pointer text-t-foreground underline group-data-[show-clear-all="false"]/toggle-clear-all:hidden'
                  target-clear-all-filters
                  @click=${this.clearAllFilters}
                >
                  ${this.textClearAll}
                </button>
              </div>
            `:x}
      </div>
    `}getSortHTML(t,e){return o`
      ${e=="Desktop"?o` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="max-md:hidden"
          >
            <form
              id="SortOptionsForm${e}"
              class="gap-2xs${window.brand=="TFC"?" !font-normal":""} text-utility-bold flex"
            >
              <label for="SortBy">${this.textSort}:</label>
              <div class="relative">
                <select
                  name="sort_by"
                  id="SortBy"
                  aria-describedby="a11y-refresh-page-message"
                  class="outline-none${window.brand=="TFC"?" bg-transparent":""} block w-full appearance-none pr-sm"
                  @change=${this.handleSelectChange}
                >
                  ${w(t??[],a=>a.sort_by+e,a=>{var s;return o`
                      <option
                        value="${a.sort_by}"
                        ${a.status!=""?' selected="selected"':""}
                      >
                        ${(s=a.display_name)==null?void 0:s.replace("Most Relevant","Featured")}
                      </option>
                    `})}
                </select>
                <svg-icon
                  src="icon-select-arrow"
                  class="pointer-events-none absolute right-0 top-2/4 -translate-y-2/4"
                  style="--icon-size: 16px;"
                ></svg-icon>
              </div>
            </form>
          </facet-filters-form>`:o` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="flex h-full"
          >
            <form
              id="SortOptionsForm${e}"
              class="flex w-full flex-col"
            >
              <div
                id="SortOptionsForm${e}_sort"
                class="group/facet max-md:px-pagegridmargin max-md:py-md md:pb-sm"
                sub-section-id="SortOptionsForm${e}_sort"
                data-sort-by="title-ascending"
              >
                <ul class="list-unstyled space-y-xs md:space-y-2xs" role="list">
                  ${w(t??[],a=>a.sort_by+e,a=>o`
                      <li class="py-2xs" data-selected="false">
                        <div
                          class="group/radio flex w-full min-w-0 items-start justify-start gap-x-xs"
                        >
                          <div
                            class="peer relative flex shrink-0 cursor-pointer items-center rounded-full"
                          >
                            <input
                              type="radio"
                              class="peer relative size-4 cursor-pointer appearance-none rounded-full border border-t-foreground-secondary text-t-foreground-secondary transition-all checked:border-t-foreground-secondary disabled:border-t-border"
                              id="sortoptionsform${e}_input_${a.sort_by}"
                              name="sort_by"
                              value="${a.sort_by}"
                              @change=${this.handleSelectChange}
                              .checked=${a.status!=""}
                            />
                            <span
                              class="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 scale-0 text-t-foreground opacity-0 transition-[opacity,transform-] peer-checked:scale-100 peer-checked:opacity-100"
                            >
                              <svg-icon
                                src="icon-radio-circle"
                                class="block"
                                style="--icon-size: 10px;"
                              ></svg-icon>
                            </span>
                          </div>
                          <label
                            class="mt-px flex-1 cursor-pointer select-none"
                            for="sortoptionsform${e}_input_${a.sort_by}"
                          >
                            <div>
                              <p
                                id="sortoptionsform${e}_input_${a.sort_by}_label"
                                class="text-body block leading-none text-t-foreground group-has-[:disabled]/radio:text-t-disabled"
                              >
                                ${a.display_name.replace("Most Relevant","Featured")}
                              </p>
                            </div>
                          </label>
                        </div>
                      </li>
                    `)}
                </ul>
              </div>
            </form>
          </facet-filters-form>`}
    `}getPaginationArray(t,e){const s=[];if(s.push("1"),e<=6)for(let r=2;r<e;r++)s.push(r);else if(t<=3){for(let r=2;r<=4;r++)s.push(r);s.push("...")}else if(t>=e-2){s.push("...");for(let r=e-3;r<e;r++)s.push(r)}else s.push("..."),s.push(t-1),s.push(t),s.push(t+1),s.push("...");return s[s.length-1]!==e&&s.push(e),s.map(r=>r.toString())}getPaginateHTML(t,e=1){if(!t)return;const a=this.getPaginationArray(e,t.length);if(a)return o`
      ${(t==null?void 0:t.length)>1?o`
            <div class="flex justify-center px-lg pb-lg pt-md">
              <ul
                class="flex list-none items-center justify-center gap-2.5"
                role="list"
              >
                ${(t==null?void 0:t.length)>1?o`
                      <li class="inline-flex list-none">
                        <button
                          class="${e===1?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="-1"
                          ?disabled=${e===1}
                          aria-disabled="${e===1}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src="icon-caret"
                            class="pointer-events-none block"
                            style="--icon-size: 16px; rotate: 90deg;"
                          ></svg-icon>
                        </button>
                      </li>
                    `:x}
                ${w(a,s=>"productPage"+s,s=>o`
                    ${s!="..."?o`
                          <li class="inline-flex list-none">
                            <button
                              class="${s==e.toString()?`${window.brand=="NG"?"border-t-foreground-secondary bg-t-accent-04":"border-t-foreground"}`:"border-t-border"} ${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border"
                              aria-current="${s==e.toString()?"page":x}"
                              @click=${this.paginateHandleClick}
                            >
                              <span class="utility-standard pointer-events-none"
                                >${s}</span
                              >
                            </button>
                          </li>
                        `:o`
                          <li class="inline-flex list-none">
                            <span
                              class="${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border border-t-border"
                            >
                              <span class="utility-standard pointer-events-none"
                                >…</span
                              >
                            </span>
                          </li>
                        `}
                  `)}
                ${(t==null?void 0:t.length)>1?o`
                      <li class="inline-flex list-none">
                        <button
                          class="${e===t.length?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="1"
                          ?disabled=${e===t.length}
                          aria-disabled="${e===t.length}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src="icon-caret"
                            class="pointer-events-none block"
                            style="--icon-size: 16px; rotate: -90deg;"
                          ></svg-icon>
                        </button>
                      </li>
                    `:x}
              </ul>
            </div>
          `:x}
    `}removeFacet(t){const e=t.target;if(e.dataset.name=="price")this.currentPage=1,this.filterChanged(e.closest("collection-results-section"),e);else{const a=this.querySelector(`[target-filters][is-mobile] [name="${e.dataset.name}"][value="${e.dataset.value}"]`);a&&a.click()}}getFacetRemove(t,e){return o`
      <facet-remove
        class="flex cursor-pointer snap-center items-center gap-2xs whitespace-nowrap rounded-sm bg-t-background-secondary px-xs py-[0.438rem]"
        data-name="${t.name}"
        data-value="${t.display_name}"
        @click=${this.removeFacet}
      >
        <svg-icon
          src="icon-close"
          class="pointer-events-none block"
          style="--icon-size: 8px"
        ></svg-icon>
        <span
          class="text-utility-regular pointer-events-none text-t-foreground"
        >
          ${t.type=="range"?o`$${L(t.min)} -
              $${j(t.max)}`:t.name=="rating_tier"?o`
                  <div class="flex items-center gap-1">
                    ${w([1,2,3,4,5],a=>"star"+a+e,a=>a<=parseFloat(t.display_name)?o`<svg-icon
                              src="icon-star-full"
                              class="block text-t-accent-01"
                              style="--icon-size: 16px;"
                            ></svg-icon>`:o`<svg-icon
                              src="icon-star-empty"
                              class="block text-t-foreground-secondary"
                              style="--icon-size: 16px;"
                            ></svg-icon>`)}
                  </div>
                `:o`${t.display_name}`}
        </span>
      </facet-remove>
    `}getFilteredFacets(t,e){if(!(t!=null&&t.length))return o``;const a=(t==null?void 0:t.reduce((s,r)=>{if(r.type!=="range"){const n=r.options.filter(i=>i.status==="selected").map(i=>({...i,name:r.name}));return s.concat(n)}else{const n=Object.hasOwn(r.status,"min")&&Object.hasOwn(r.status,"max"),i=r.status.min!==r.min,p=r.status.max<(this._productsMaxPrice??r.max);return n&&(i||p)&&s.push({...r,min:r.status.min,max:r.status.max}),s}},[]))??[];return o`
      <div
        class="empty:pt-0${e=="Desktop"?" max-md:hidden":""} col-span-full w-full pt-sm empty:hidden"
        data-target-facet-removes="${e==null?void 0:e.toLowerCase()}"
      >
        ${a.length>0?o` <facet-filters-form
              section-id="facet-filters"
              class="[&amp;[loading]]:opacity-50 [&amp;[loading]]:pointer-events-none flex h-full w-full"
              data-mode="facet-removes"
              data-form-id="FacetRemovesForm${e}"
              data-filters-form-id="FacetFiltersForm${e}"
            >
              <form
                id="FacetRemovesForm${e}"
                class="${e=="Desktop"?"flex-wrap":"no-scrollbar overflow-x-auto snap-x snap-mandatory px-xs"} flex w-full items-center gap-2xs"
              >
                ${w(a??[],s=>s.name,s=>this.getFacetRemove(s,e))}
                ${e=="Desktop"?o`<facet-remove
                      class="text-utility-bold ml-2xs cursor-pointer text-t-foreground underline"
                      target-clear-all-filters
                      @click=${this.clearAllFilters}
                    >
                      ${this.textClearAll}
                    </facet-remove>`:x}
              </form>
            </facet-filters-form>`:x}
      </div>
    `}getModalDialog(t,e,a,s,r,n,i,p,l){return o`
      <modal-dialog
        cloak
        type="${r}"
        id="${t}"
        anchor="${e}"
        close-on-backdrop-click="true"
        drawer-classes="${l}"
        close-icon-size="${i}"
      >
        <div slot="header" class="${p} h6">${n}</div>
        <div slot="additional-content">${s}</div>
        <form target-filters is-mobile class="h-full">${a}</form>
      </modal-dialog>
    `}render(){var t,e,a,s,r,n,i,p,l,d;return o` <search-results-section
      class="grid grid-cols-1 pb-sm 2xl:container md:grid-cols-[minmax(0,295px)_minmax(0,1fr)] md:gap-x-lg md:gap-y-xs md:px-pagemargin"
      data-pagination-results-per-page="${this.resultsPerPage}"
      target-content-results
      data-cnstrc-browse
      data-cnstrc-filter-name="type"
      data-cnstrc-filter-value="${this.type}"
      data-cnstrc-num-results="${((t=this.resourcesData)==null?void 0:t.totalResults)??0}"
    >
      ${this.getFilteredFacets(this.resourcesData.facets,"Desktop")}
      <aside class="md:block md:pb-6">
        <div class="max-md:hidden">
          <form target-filters>
            ${this.getFacetsHTML((e=this.resourcesData)==null?void 0:e.facets,"Desktop")}
          </form>
        </div>

        ${this.getModalDialog("filter-drawer-dialog-content","left",this.getFacetsHTML((a=this.resourcesData)==null?void 0:a.facets,"Mobile","filter-drawer-dialog-content"),this.getFilteredFacets(this.resourcesData.facets,"Mobile"),"drawer",this.textFilterResults,13,"!h4","!max-w-[22.5rem] !overflow-clip !text-t-foreground")}
        ${this.getModalDialog("sort-options-drawer-dialog-content","left",this.getSortHTML((s=this.resourcesData)==null?void 0:s.sortOptions,"Mobile"),o``,"drawer",this.textSort,13,"!h4","!max-w-[22.5rem]")}
      </aside>

      <div class="flex-grow" content-category-results="resources">
        <div>
          <div>
            <div
              id="content-grid-header-search"
              class="product-grid-header mb-sm flex flex-col md:mt-sm md:flex-row md:items-center md:justify-between md:gap-sm"
            >
              <div class="flex">
                <dialog-toggle
                  modal-id="filter-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-filters"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textFilter}</span
                    >
                  </button>
                </dialog-toggle>
                <dialog-toggle
                  modal-id="sort-options-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border-y border-r border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-sorting"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textSort}</span
                    >
                  </button>
                </dialog-toggle>
                ${this.getSortHTML((r=this.resourcesData)==null?void 0:r.sortOptions,"Desktop")}
              </div>
              <span
                class="${window.brand=="NG"?"text-t-disabled":"text-t-foreground-secondary"} text-utility-regular max-md:mb-2xs max-md:mt-sm max-md:w-full max-md:px-pagegridmargin md:order-[-1]"
                >${(n=this.resourcesData)!=null&&n.totalResults?(((i=this.resourcesData)==null?void 0:i.totalResults)==1?this.dataResultsGridWithCountOne:this.dataResultsGridWithCountOther).replace("{{ count }}",`${(l=(p=this.resourcesData)==null?void 0:p.totalResults)==null?void 0:l.toLocaleString("en-US")}`):x}</span
              >
            </div>
            <div>
              <div
                class="grid gap-y-xs max-md:px-pagegridmargin md:grid-cols-2 md:gap-x-xs md:gap-y-md lg:grid-cols-4 lg:gap-y-7"
              >
                ${w(((d=this.resourcesData)==null?void 0:d.cards)??[],b=>b.id,b=>o`
                    <dynamic-card
                      handle="${b.handle}"
                      class="group/dynamic-card"
                      view="article-card"
                      query-type="article"
                      article-type="${this.type}"
                    >
                      <div
                        data-slot="article-card-skeleton"
                        class="relative grid w-full items-center gap-xs group-has-[a]/dynamic-card:hidden"
                      >
                        <div
                          data-slot="article-card-skeleton-image"
                          class="${window.brand=="NG"?"rounded-sm":""} block aspect-square animate-pulseskeleton overflow-clip bg-t-border"
                        ></div>
                        <div class="flex flex-col gap-2xs">
                          <div
                            data-slot="article-card-skeleton-caption"
                            class="${window.brand=="NG"?"rounded-sm":""} caption h-[1em] max-w-10 animate-pulseskeleton bg-t-border"
                          ></div>
                          <div
                            data-slot="article-card-skeleton-title"
                            class="${window.brand=="NG"?"rounded-sm":""} text-heading-6 h-[1em] max-w-[90%] animate-pulseskeleton bg-t-border font-medium leading-[1.2]"
                          ></div>
                          <div
                            data-slot="article-card-skeleton-exerpt"
                            class="${window.brand=="NG"?"rounded-sm":""} text-caption h-[1em] max-w-[80%] animate-pulseskeleton bg-t-border"
                          ></div>
                          <div
                            data-slot="article-card-skeleton-exerpt"
                            class="${window.brand=="NG"?"rounded-sm":""} text-caption h-[1em] max-w-[50%] animate-pulseskeleton bg-t-border"
                          ></div>
                        </div>
                      </div>
                    </dynamic-card>
                  `)}
              </div>
            </div>
            ${this.getPaginateHTML(this.resourcesData.paginationIds,this.currentPage)}
          </div>
        </div>
      </div>
    </search-results-section>`}};m([g({type:String,attribute:"data-sort"})],h.prototype,"textSort",2);m([g({type:String,attribute:"data-filter"})],h.prototype,"textFilter",2);m([g({type:String,attribute:"data-filter-counter"})],h.prototype,"textFilterCounter",2);m([g({type:String,attribute:"data-filters-counter"})],h.prototype,"textFiltersCounter",2);m([g({type:String,attribute:"data-see-result"})],h.prototype,"textDataSeeResult",2);m([g({type:String,attribute:"data-see-results"})],h.prototype,"textDataSeeResults",2);m([g({type:String,attribute:"data-hide-count"})],h.prototype,"textHideCount",2);m([g({type:String,attribute:"data-view-all-count"})],h.prototype,"textViewAllCount",2);m([g({type:String,attribute:"data-apply"})],h.prototype,"textApply",2);m([g({type:String,attribute:"data-no-options-match-search"})],h.prototype,"textNoOptionsMatchSearch",2);m([g({type:String,attribute:"data-clear-all"})],h.prototype,"textClearAll",2);m([g({type:String,attribute:"data-results-grid-with-count-one"})],h.prototype,"dataResultsGridWithCountOne",2);m([g({type:String,attribute:"data-results-grid-with-count-other"})],h.prototype,"dataResultsGridWithCountOther",2);m([g({type:String})],h.prototype,"type",2);m([g({type:Number})],h.prototype,"facetsCheckboxVisibleLimit",2);m([g({type:Number})],h.prototype,"currentPage",2);m([g({type:Number,attribute:"results-per-page"})],h.prototype,"resultsPerPage",2);m([g({type:Object})],h.prototype,"resourcesData",2);m([g({type:String})],h.prototype,"textFilterResults",2);h=m([E("resource-results")],h);
